import { PayloadAction } from 'typesafe-actions';
import { UserInfoProviderState, UserProfileActionTypes } from './types';

const UserProfileReducer = (
  state: UserInfoProviderState,
  action: PayloadAction<UserProfileActionTypes, any>,
): UserInfoProviderState => {
  switch (action.type) {
    case UserProfileActionTypes.setSelectedCustomerId:
      return {
        ...state,
        selectedCustomerId: action.payload,
      };
    case UserProfileActionTypes.setEntitlement:
      return {
        ...state,
        entitlements: action.payload,
      };
    default: {
      return state;
    }
  }
};

export { UserProfileReducer };
